import { rest as API } from './rest';

const basePath = ({ customerUUID, ecosystemUUID }) => `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/users`;

export const getUserList = (params) => API.get(basePath(params)).then(({ data }) => data);

export const inviteUsers = ({ customerUUID, ecosystemUUID, payload }) =>
  API.post(`/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/invite`, payload).then(({ data }) => data);

export const enableDisableMFAForUsers = (params) =>
  API.put(`${basePath(params)}/auth`, params.payload).then(({ data }) => data);

export const resetMFAForUsers = (params) =>
  API.put(`${basePath(params)}/reset`, params.payload).then(({ data }) => data);

export const getLDAPToken = ({ customerUUID, ecosystemUUID, userUUID }) =>
  API.post(`${basePath({ customerUUID, ecosystemUUID })}/${userUUID}/token`).then(({ data }) => data);
